var _circle, _mask, _path, _path2, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.5419,
    r: 16.5,
    fill: "white",
    stroke: "#EFEFEF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8.54187H14L12.6667 10.5419H9C7.89543 10.5419 7 11.4373 7 12.5419V24.5419C7 25.6464 7.89543 26.5419 9 26.5419H25C26.1046 26.5419 27 25.6464 27 24.5419V12.5419C27 11.4373 26.1046 10.5419 25 10.5419H21.3333L20 8.54187Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8.54187H14L12.6667 10.5419H9C7.89543 10.5419 7 11.4373 7 12.5419V24.5419C7 25.6464 7.89543 26.5419 9 26.5419H25C26.1046 26.5419 27 25.6464 27 24.5419V12.5419C27 11.4373 26.1046 10.5419 25 10.5419H21.3333L20 8.54187Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.54187V7.54187H13.4648L13.1679 7.98717L14 8.54187ZM20 8.54187L20.8321 7.98717L20.5352 7.54187H20V8.54187ZM12.6667 10.5419V11.5419H13.2019L13.4987 11.0966L12.6667 10.5419ZM21.3333 10.5419L20.5013 11.0966L20.7981 11.5419H21.3333V10.5419ZM14 9.54187H20V7.54187H14V9.54187ZM13.4987 11.0966L14.8321 9.09657L13.1679 7.98717L11.8346 9.98717L13.4987 11.0966ZM9 11.5419H12.6667V9.54187H9V11.5419ZM8 12.5419C8 11.9896 8.44772 11.5419 9 11.5419V9.54187C7.34315 9.54187 6 10.885 6 12.5419H8ZM8 24.5419V12.5419H6V24.5419H8ZM9 25.5419C8.44772 25.5419 8 25.0942 8 24.5419H6C6 26.1987 7.34315 27.5419 9 27.5419V25.5419ZM25 25.5419H9V27.5419H25V25.5419ZM26 24.5419C26 25.0942 25.5523 25.5419 25 25.5419V27.5419C26.6569 27.5419 28 26.1987 28 24.5419H26ZM26 12.5419V24.5419H28V12.5419H26ZM25 11.5419C25.5523 11.5419 26 11.9896 26 12.5419H28C28 10.885 26.6569 9.54187 25 9.54187V11.5419ZM21.3333 11.5419H25V9.54187H21.3333V11.5419ZM19.1679 9.09657L20.5013 11.0966L22.1654 9.98717L20.8321 7.98717L19.1679 9.09657Z",
    fill: "#797979",
    mask: "url(#path-2-inside-1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 18.5419,
    r: 5,
    fill: "white",
    stroke: "#797979"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 18.5419,
    r: 3,
    fill: "#E38A43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCamera);
export default __webpack_public_path__ + "static/media/ProfileCamera.3dbdef8e6b2c795cc55ab12a708d1d98.svg";
export { ForwardRef as ReactComponent };